/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.98"
        height="18.65"
        viewBox="0 0 18.98 18.65"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M1 8.94v8.71h17V8.94h1v9.71H0V8.94ZM10 0v11.17l4.2-4.23.71.71L10 12.58v.09h-.09l-.39.39-.39-.39H9v-.13L4.06 7.62l.71-.7L9 11.13V0Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ArrowDownIntoBoxIcon';

export default Icon;
